<div class="editprofilewrapper">
  <div class="d-flex editwrapper">
    <div class="editprofilecontent text-heading-3">Edit Profile</div>
    <button class="primary-btn update" (click)="onSubmit(f)">Update</button>
  </div>
  <form #f="ngForm" name="form" novalidate>
    <div class="dialog-content-block p-3">
      <div class="dialog-content-block">
        <div class="form-group">
          <h6 class="text-start text-dark">Username</h6>
          <input type="text" name="username" [(ngModel)]="user.username">
          <div class="form-error-msg"></div>
        </div>
      </div>
      <div class="d-flex gap-5 w-100 mt-4">
        <div class="w-50 d-flex flex-column">
          <div class="form-group">
            <h6 class="text-start text-dark">First Name</h6>
            <input type="text" name="firstname" [(ngModel)]="user.first_name">
            <div class="form-error-msg"></div>
          </div>
        </div>
        <div class="w-50 d-flex flex-column">
          <div class="form-group">
            <h6 class="text-start text-dark">Last Name</h6>
            <input type="text" name="lastname" [(ngModel)]="user.last_name">
            <div class="form-error-msg"></div>
          </div>
        </div>
      </div>
      <div class="d-flex gap-5 w-100 mt-4">
        <div class="w-50 d-flex flex-column">
          <div class="form-group">
            <h6 class="text-start text-dark">Email</h6>
            <input type="text" name="email" [(ngModel)]="user.email">
            <div class="form-error-msg"></div>
          </div>
        </div>
        <div class="w-50 d-flex flex-column">
          <div class="form-group">
            <h6 class="text-start text-dark">Contact Number</h6>
            <input type="text" name="contactnumber" [(ngModel)]="user.contact_number">
            <div class="form-error-msg"></div>
          </div>
        </div>
      </div>
      <div class="d-flex gap-5 w-100 mt-4">
        <div class="w-50 d-flex flex-column">
          <div class="form-group">
            <h6 class="text-start text-dark">Default Store</h6>
                <div class="custom-input position-relative cursor-pointer" (click)="openStoreDropdown($event)">
                  <input type="hidden" #role="ngModel" [(ngModel)]="user.default_store_id" name="store_id" required>
                  <p>{{ selectedStoreName !== "" ? selectedStoreName : "Select Store" }}</p>
                  <img class="position-absolute input-dropdown" src="../../../assets/images/dropdown.svg" alt="down_arrow" srcset="">

                  <div id="roles-dropdown" class="w-100 roles-dropdown position-absolute">
                      <ul *ngIf="stores.length !== 0">
                          <li class="text-capitalize" *ngFor="let store of stores" (click)="onStoreChange(store)">{{ store.name }}</li>
                      </ul>
                      <ul *ngIf="stores.length === 0">
                          <li>No Store available</li>
                      </ul>
                  </div>
              </div>
            <div class="form-error-msg"></div>
          </div>
        </div>
      </div>
    </div>
  </form>
  <app-toast-message></app-toast-message>
</div>
